// ATTENTION PATIENT API
import Request from '../base'
export default {
    save (options) {
        return Request.post('/ebermain/mainapi/patient/attention/save', options)
    },
    delete (options) {
        return Request.post('/ebermain/mainapi/patient/attention/delete', options)
    },
    load (options) {
        return Request.post('/ebermain/mainapi/patient/attention/load', options)
    },
    list (options) {
        return Request.post('/ebermain/mainapi/patient/attention/list', options)
    }
}
